function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isString.js
// module id = 41
// module chunks = 33587185282056 114276838955818